"use strict";

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

function baseLinkStyles(_) {
  return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        color: ", ";\n        text-decoration: ", ";\n\n        &:hover {\n            color: ", ";\n            text-decoration: ", ";\n        }\n    "], ["\n        color: ", ";\n        text-decoration: ", ";\n\n        &:hover {\n            color: ", ";\n            text-decoration: ", ";\n        }\n    "])), function (_a) {
    var theme = _a.theme,
        active = _a.active,
        contrast = _a.contrast;
    return active ? contrast ? theme.link.contrastActiveColor : theme.link.activeColor : contrast ? theme.link.contrastColor : theme.link.color;
  }, function (_a) {
    var theme = _a.theme;
    return theme.link.decoration;
  }, function (_a) {
    var theme = _a.theme,
        contrast = _a.contrast;
    return contrast ? theme.link.hover.contrastColor : theme.link.hover.color;
  }, function (_a) {
    var theme = _a.theme;
    return theme.link.hover.decoration;
  });
}

exports.baseLinkStyles = baseLinkStyles;
var templateObject_1;